import { toast } from 'react-toastify';

export const handleApiError = (error) => {
  console.error('API Error:', error);
  toast.error(error.response?.data?.message || 'An unexpected error occurred');
};